export default "__VITE_ASSET__9AWqUU6K__"